import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取仪表盘列表
export function getList(params) {
  return request({
    url: URL.external.businessIntelligenceDashboard.getList,
    method: 'get',
    params
  })
}

// 添加仪表盘
export function add(data) {
  return request({
    url: URL.external.businessIntelligenceDashboard.addDashboard,
    method: 'post',
    data
  })
}

// 编辑仪表盘
export function editDashboard(data) {
  return request({
    url: URL.external.businessIntelligenceDashboard.editDashboard,
    method: 'put',
    data
  })
}

// 自定义仪表盘添加时右侧列表
export function getCards(params) {
  return request({
    url: URL.external.businessIntelligenceDashboard.getCards,
    method: 'get',
    params
  })
}

// 删除仪表盘
export function deleteDashboard(params) {
  return request({
    url: URL.external.businessIntelligenceDashboard.deleteDashboard,
    method: 'delete',
    params
  })
}
// 获取自定义仪表盘筛选项
export function getFilterList(params) {
  return request({
    url: URL.external.businessIntelligenceDashboard.getFilterList,
    method: 'get',
    params
  })
}

// 获取自定义仪表盘筛选项
export function saveFilters(data) {
  return request({
    url: URL.external.businessIntelligenceDashboard.saveFilters,
    method: 'put',
    data
  })
}
// 根据公司和部门获取指定权限下面的用户
export function getUsersByOfficeAndDept(params) {
  return request({
    url: URL.order.getUsersByOfficeAndDept,
    method: 'get',
    params
  })
}

// 获取仪表盘url
export function getDashboardUrl(data) {
  return request({
    url: URL.external.businessIntelligenceDashboard.getDashboardUrl,
    method: 'post',
    data
  })
}

